import React from 'react';
import styles from './view.module.css';

const TOPIC_LABELS = {
  inbox_delivery: 'Inbox Delivery',
  automation: 'Automation',
  api_integration: 'API Integration',
  email_marketing: 'Email Marketing',
  analytics: 'Analytics',
  integrations: 'Integrations'
};

const Field = ({ label, value }) => {
  if (!value && value !== 0) return null;
  return (
    <div className={styles.field}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
};

export const DemoDetail = ({ demo }) => {
  if (!demo) return null;
  const m = demo.meta || {};

  const full_name = [m.first_name, m.last_name].filter(Boolean).join(' ') || '—';
  const initial = (m.first_name || '?').charAt(0).toUpperCase();

  return (
    <div className={styles.wrapper}>
      <div className={styles.avatar}>{initial}</div>
      <h3 className={styles.name}>{full_name}</h3>
      {m.role && <p className={styles.role}>{m.role}</p>}
      {m.company && <p className={styles.company}>{m.company}</p>}

      {m.meet_link && (
        <a className={styles.meetLink} href={m.meet_link} target="_blank" rel="noreferrer noopener">
          Join Meeting
        </a>
      )}

      <div className={styles.fields}>
        <Field label="Email" value={m.email} />
        <Field label="Phone" value={m.phone || m.phone_number} />
        <Field label="Industry" value={m.industry} />
        <Field
          label="List Size"
          value={m.list_size?.toLocaleString() || m.subscribers?.toLocaleString()}
        />
        <Field label="Meeting Date" value={m.meeting_date} />
        <Field label="Meeting Time" value={m.meeting_time} />
        {m.notes && <Field label="Notes" value={m.notes} />}
      </div>

      {Array.isArray(m.demo_topics) && m.demo_topics.length > 0 && (
        <div className={styles.topicsSection}>
          <span className={styles.topicsLabel}>Topics</span>
          <div className={styles.topics}>
            {m.demo_topics.map((t) => (
              <span key={t} className={styles.topic}>
                {TOPIC_LABELS[t] || t}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
